import { Box, Paper, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { colors } from "@components/ui/colors";

export const LocalNumberBenefitCard = () => {
    return (
        <Paper
            elevation={0}
            sx={{
                background: `linear-gradient(135deg, ${colors.orange[50]}, ${colors.yellow[50]})`,
                border: `1.5px solid ${colors.orange[200]}`,
                borderRadius: "16px",
                p: 2.25,
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    mb: 1.25,
                }}
            >
                <InfoOutlinedIcon
                    sx={{
                        color: colors.orange[500],
                        fontSize: 18,
                    }}
                />

                <Typography
                    sx={{
                        fontSize: 13,
                        fontWeight: 700,
                        color: colors.orange[700],
                    }}
                >
                    Why a local number?
                </Typography>
            </Box>

            <Typography
                sx={{
                    fontSize: 12,
                    color: colors.gray[400],
                    lineHeight: 1.7,
                    fontWeight: 500,
                }}
            >
                Local presence builds trust. Customers are more likely to answer calls
                from a local area code than from toll-free numbers.
            </Typography>
        </Paper>
    );
};